import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {delay, distinctUntilChanged, map, repeatWhen, take, takeWhile, toArray} from "rxjs/operators";
import {GlobalVariablesService} from "../../providers/service/global-variables.service";
import {FormBuilder} from "@angular/forms";

@Component({
    selector: 'app-scroll-with-button',
    templateUrl: './scroll-with-button.component.html',
    styleUrls: ['./scroll-with-button.component.scss'],
    standalone: false
})
export class ScrollWithButtonComponent implements OnDestroy, AfterViewInit {
    @ViewChild('scrollDiv') scrollDiv: ElementRef | undefined;

    @Input() visualizeButtonLeftRight = true
    @Input() position: 'top' | 'bottom' | 'overlay' = 'top';
    @Input() color: 'accent' | 'primary' | 'warn' = 'accent';
    @Input() step = 5;
    valueScroll: number | null = 0;


    subscription: Subscription = new Subscription();

    maxScrolWith = 0;
    public formGroup;

    constructor(private globalVariableService: GlobalVariablesService, fb: FormBuilder) {
        this.formGroup = fb.group({sliderValue: 0})
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

    }

    ngAfterViewInit(): void {
        this.setMaxScroll();
        const resize$ = new Observable(
            subscriber => {
                const clientWidth = this.scrollDiv!.nativeElement.clientWidth;
                subscriber.next(clientWidth);
                subscriber.complete();
            }
        )
        this.subscription.add(resize$.pipe(
                repeatWhen((a) => {
                    return a.pipe(delay(400))
                }),
                distinctUntilChanged(),
                takeWhile(clientWidth => {
                    return clientWidth == 0;
                }),
                take(10),
                toArray(),
                map(clientWidths => {
                    return clientWidths[clientWidths.length - 1]
                })
            ).subscribe(
                clientWidth => {
                    this.setMaxScroll();
                },
                error => {
                    console.log(error)
                }
            )
        )
    }

    setMaxScroll() {
        setTimeout(() => {
            let maxScrolWith
            if (this.scrollDiv != null && this.scrollDiv.nativeElement != null) {
                const scrollWidth = this.scrollDiv.nativeElement.scrollWidth;
                const clientWidth = this.scrollDiv.nativeElement.clientWidth;
                maxScrolWith = scrollWidth - clientWidth;
            } else {
                maxScrolWith = 0;
            }
            this.maxScrolWith = maxScrolWith
        })
    }

    public stopScrool: Subscription = new Subscription();

    activeScroll(direction: 'right' | 'left') {
        if (direction === "right") {
            this.valueScroll = Math.ceil(Math.min(this.valueScroll! + this.step, 100));
        } else {
            this.valueScroll = Math.floor(Math.max(0, this.valueScroll! - this.step));
        }
        this.moveSlider(this.valueScroll);
    }

    stoppingScroll() {
        if (this.stopScrool) {
            this.stopScrool.unsubscribe()
        }
    }

    public get isMobile() {
        return this.globalVariableService.isMobile
    }

    moveSlider(event: any) {
        const value = event
        this.scrollDiv!.nativeElement.scrollTo({
            left: this.maxScrolWith * (event / 100),
            behavior: 'smooth'
        });
    }
}
